import React from "react";
import { Button } from "./ui/button";
import {
  ChefHat,
  Phone,
  Mail,
  MapPin,
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  Youtube,
} from "lucide-react";

const Footer = () => {
  const footerLinks = {
    Product: ["Features", "Pricing", "Demo", "Case Studies", "Integration"],
    Solutions: [
      "Small Cafes",
      "Restaurants",
      "Food Chains",
      "Cloud Kitchens",
      "Bakeries",
    ],
    Support: [
      "Help Center",
      "Live Chat",
      "Phone Support",
      "Training Videos",
      "Setup Guide",
    ],
    Company: ["About Us", "Careers", "Press", "Contact", "Partners"],
  };

  const contactInfo = {
    phone: "+91-9876543210",
    email: "hello@finedine.co.in",
    address: "123 Tech Hub, Sector 18, Gurugram, Haryana 122015",
  };

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16"> */}

      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © 2024 FineDine by{" "}
              <a
                href="https://s3dev.onrender.com/"
                target="_blank"
                className="underline"
              >
                S3Devs
              </a>
              . All rights reserved.
            </div>
            {/* <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors">
                Cookie Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors">
                Refund Policy
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
